import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
import PublishActivateDeactivateModal from '../../common/PublishActivateDeactivateModal';

const Categories = ({ persona }) => {
    const [t] = useTranslation();
    const [data, setData] = useState([]);
    const [confirmActivateModal, setConfirmActivateModal] = useState({ open: false, record: null });
    const [paginationParams, setPaginationParams] = useState({
          limit: 10,
          offset: 0,
          sortField: "createdAt",
          sortOrder: -1
        });

    const navigate = useNavigate();

  //   const exportCSV = (selectionOnly) => {
  //     dt.current?.exportCSV({ selectionOnly });
  //   };
  //   const renderHeader = () => {
  //     return (
  //         <div className="flex justify-content-between">
  //             <PButton type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} />
  //             <IconField iconPosition="left">
  //                 <InputIcon className="pi pi-search" />
  //                 {/* <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" /> */}
  //                 <InputText type="search" value={globalFilter} onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search" />

  //             </IconField>
  //         </div>
  //     );
  // };

    // const handleSubComponentEvent = () => {
    //   console.log('Event triggered inside SubComponent!');
    // };

    useEffect(() => {
      fetchCategories();
    }, [paginationParams]);
     
    const fetchCategories = async () => {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/categories`, { withCredentials: true })
      .catch((err) => {
          console.log(err);
      });

      setData(response?.data.map(category => ({...category, end_users_count: category.end_users?.length || 0, createdAt: new Date(category.createdAt).toLocaleString('en-GB')})));
  };
  
  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
    { field: "id", header: "ID", sortable: true },
    { field: "name", header: t("name"), sortable: true, filter: true },
    { field: "end_users_count", header: t("No. of Users"), sortable: true, filter: true },
    { field: "createdAt", header: t("createdAt"), sortable: true, filter: true },
  ];

  const actions = [
    { text: "Users", color: "primary", onClick: (row) => navigate(`/${persona}/categories/${row.id}/${encodeURIComponent(row.name)}-users`, { state: { category: row } }) },
    { text: t("edit"), color: "secondary", onClick: (row) => navigate(`/${persona}/categories/edit/${row.id}`) },
    { text: 'Publish / Activate / Deactivate', color: "primary", onClick: (row) => setConfirmActivateModal({ open: true, record: row }), status:"success" }
  ];

    return (
      <div>

        <DataTableComponent
          data={data}
          columns={columns}
          actions={actions}
          totalRecords={data?.length}
          enableCreate={true}
          enablePagination={true}
          enableLazyLoading={false}
          enableExport={true}
          paginationParams={paginationParams}
          onDataTableEvent={onDataTableEvent}
        />
        
        {confirmActivateModal.open && (
          <PublishActivateDeactivateModal
            sentData={confirmActivateModal.record}
              onEvent={setConfirmActivateModal}
              onConfirm={fetchCategories}
              apiPath="categories"
              axios={axiosInstance}
              columnName="name"
              dbAction="status"
              sectionName={"Categories"}
          />
        )}
            
      </div>
    );
};

export default Categories;